(function(){
  'use strict';
  var canvas=document.getElementById('shoe-2d');
  if(!canvas)return;
  var ctx=canvas.getContext('2d',{willReadFrequently:true});
  var urls=window.MDS_2D_ASSETS||{};
  var cache={},source=null,sourceKey='',request=0;
  function clamp(v){return Math.max(0,Math.min(255,v))}
  function smooth(a,b,v){var t=Math.max(0,Math.min(1,(v-a)/(b-a)));return t*t*(3-2*t)}
  function tint(d,i,color,anchor,amount){
    var r=d[i],g=d[i+1],b=d[i+2],lum=.2126*r+.7152*g+.0722*b;
    var factor=.68+.58*smooth(18,125,lum);
    for(var c=0;c<3;c++)d[i+c]=clamp(d[i+c]*(1-amount)+color[c]*factor*amount);
  }
  function buckleRing(x,y,cx,cy,rx,ry){
    var dx=(x-cx)/rx,dy=(y-cy)/ry,rad=dx*dx+dy*dy;
    return rad>.38&&rad<1.2;
  }
  function render(state,key){
    if(!source||sourceKey!==key)return;
    var reis=key==='reis';
    var leatherColors={cognac:[153,92,49],ebano:[31,30,30],bordo:reis?null:[122,55,62],verde:[49,75,56],oceano:reis?[39,55,75]:null};
    var leather=leatherColors[state.leather],rubber=state.sole==='borracha';
    var metal={silver:[187,192,197],bronze:[147,99,63]}[state.detail]||null;
    if(!leather&&!rubber&&!metal){ctx.putImageData(source,0,0);return}
    var frame=new ImageData(new Uint8ClampedArray(source.data),source.width,source.height);
    var d=frame.data,w=frame.width,h=frame.height;
    for(var y=0;y<h;y++)for(var x=0;x<w;x++){
      var i=(y*w+x)*4,r=d[i],g=d[i+1],b=d[i+2],lum=.2126*r+.7152*g+.0722*b;
      if(reis){
        var buckle=buckleRing(x,y,492,357,67,72)||buckleRing(x,y,780,508,71,72);
        var isMetal=buckle&&r>130&&g>105&&b<g*.9&&r>g*1.08;
        if(isMetal){tint(d,i,metal,155,.95);continue}
        var sole=y>430&&y<845&&x>135&&x<1585&&lum<105&&Math.abs(r-g)<42&&Math.abs(g-b)<37;
        if(sole){if(rubber)tint(d,i,[34,33,32],61,.85);continue}
        var upper=x>140&&x<1570&&y>130&&y<785&&r>g*1.13&&r>b*1.13&&lum<195;
        if(upper&&leather)tint(d,i,leather,111,smooth(34,75,r)*.96);
      }else{
        var goldZone=x>805&&x<1085&&y>315&&y<585;
        var gold=goldZone&&r-g>6&&g-b>9&&r>105&&g>68&&b<g*.83;
        if(gold){if(metal)tint(d,i,metal,155,.95);continue}
        var tan=!goldZone&&y>495&&y<910&&x>65&&x<1505&&r-g>6&&g-b>9&&r>70&&g>43&&g<r*.9&&b<g*.87;
        if(tan){if(rubber)tint(d,i,[42,39,36],127,smooth(62,95,r)*.95);continue}
        var dark=x>70&&x<1500&&y>145&&y<875&&lum<225&&Math.max(r,g,b)-Math.min(r,g,b)<110;
        var lining=r>g*1.23&&r>b*1.16&&x<850&&y<575;
        if(dark&&!lining&&leather)tint(d,i,leather,76,(1-smooth(165,225,lum))*.96);
      }
    }
    ctx.putImageData(frame,0,0);
  }
  function load(key,state){
    var url=urls[key];if(!url)return;
    var ticket=++request;
    if(cache[key]){show(cache[key],key,state,ticket);return}
    var image=new Image();
    image.onload=function(){cache[key]=image;show(image,key,state,ticket)};
    image.onerror=function(){canvas.style.display='none';var fallback=document.getElementById('shoe');if(fallback)fallback.style.display='block'};
    image.src=url;
  }
  function show(image,key,state,ticket){
    if(ticket!==request)return;
    canvas.style.display='block';
    canvas.width=image.naturalWidth;canvas.height=image.naturalHeight;
    ctx.drawImage(image,0,0);
    source=ctx.getImageData(0,0,canvas.width,canvas.height);sourceKey=key;
    render(state,key);
  }
  window.MDS2D={refresh:function(state){
    var selected=document.querySelector('#cfg-model input:checked');
    var model=((selected&&selected.getAttribute('data-handle'))||'').toLowerCase();
    var key=model.indexOf('reis')>-1?'reis':model.indexOf('navegante')>-1?(state.detail==='liso'?'navegantesPlain':'navegantes'):'';
    if(!key){canvas.style.display='none';var fallback=document.getElementById('shoe');if(fallback)fallback.style.display='block';return}
    if(sourceKey===key){render(state,key);return}
    load(key,state);
  }};
})();
